/** @format */

import axios from "axios";
import { message } from "antd";

message.config({
  top: 60,
  duration: 3,
  maxCount: 3,
});
axios.defaults.withCredentials = true;
axios.defaults.timeout = 20000

let parseParams = (data) => {
  try {
    var tempArr = [];
    for (var i in data) {
      var key = encodeURIComponent(i);
      var value = encodeURIComponent(data[i]);
      tempArr.push(key + "=" + value);
    }
    var urlParamsStr = tempArr.join("&");
    return urlParamsStr;
  } catch (err) {
    return "";
  }
};

export const host = "/api";
export const commodityHost = "https://api.znzmo.com";
// const linggan_host = `http://139.196.47.220${host}/znzgo`; // 正式
export const linggan_host = `https://manager.znztv.com/api/znzgo`; // 测试
// const linggan_host = `http://localhost:8080/`; // dev

axios.defaults.withCredentials = true;
const httpRequest = {
  post: async (api, param, headers) => {
    const result = await axios.post(api, param, headers);
    if (
      result.status == "401" ||
      !result.data.error ||
      result.data.error.errorCode == "90002" ||
      result.data.error.errorCode == "401"
    ) {
      window.location.href = "/login";
    }
    return result.data;
  },
  get: async (api, header) => {
    const ret = await axios.get(api, { ...header });
    if (
      ret.status == "401" ||
      !ret.data.error ||
      ret.data.error.errorCode == "90002" ||
      ret.data.error.errorCode == "401"
    ) {
      window.location.href = "/login";
    }
    return ret.data;
  },
  get2: async function (api, params, header) {
    let url = api;
    for (let key in params) {
      url += `${url.includes('?') ? '&' : '?'}${key}=${params[key] ?? ''}`;
    }

    return this.get(url, header);
  }
};

export const getPermissions = async function (param) {
  const result = await httpRequest.get(linggan_host + `/permissions`, {
    headers: { userInfo: param },
  });
  return result;
};

export const inspiration_searchword_list = async function (
  page,
  size,
  status,
  column,
  sort
) {
  let url = linggan_host + "/searchword/list?page=" + page + "&size=" + size;
  if (status !== null) {
    url += "&status=" + status;
  }
  if (sort !== null && sort !== undefined) {
    url += "&sort=" + sort;
    if (column !== null && column !== undefined) {
      url += "&column=" + column;
    }
  }
  return await httpRequest.get(url);
};

export const inspiration_searchword_count = async function () {
  return await httpRequest.get(linggan_host + "/searchword/count");
};

export const inspitation_searchword_content = async function (params) {
  return await httpRequest.get(
    linggan_host +
    "/searchword/content?searchWordId=" +
    params.searchWordId +
    `&page=${params.page}&pageSize=${params.pageSize}`
  );
};

export const inspitation_searchword_noPass = async function (searchWordId) {
  const username = localStorage.getItem("username");
  return await axios.post(linggan_host + "/searchword/noPass", searchWordId, {
    headers: { "Content-Type": "application/json", userInfo: username },
  });
};

export const inspiration_Searchword_batchHandleTag = async function (param) {
  const username = localStorage.getItem("username");
  return await httpRequest.post(
    linggan_host + "/searchword/batchHandleTag",
    param,
    { headers: { userInfo: username } }
  );
};

export const searchwordReview = async function (param) {
  const result = await httpRequest.post(
    linggan_host + `/searchword/review`,
    param
  );
  return result;
};

export const inspiration_homepage_updateColl = async function (param) {
  return await httpRequest.post(
    linggan_host + "/homepage/addHomepageColl",
    param
  );
};

export const inspiration_homepage_updateColl_a = async function (param) {
  return await httpRequest.post(
    linggan_host + "/homepage/batchUpdateColl",
    param
  );
  // return await httpRequest.post('http://192.168.1.31:82/homepage/batchUpdateColl', param)
};

export const inspiration_es_batchDelColl = async function (param) {
  return await axios.post(linggan_host + "/es/batchDelColl", param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const inspiration_es_batchDelIns = async function (param) {
  return await axios.post(linggan_host + "/es/batchDelIns", param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const inspiration_es_batchRemoveClassifyTags = async function (param) {
  return await axios.post(linggan_host + "/es/batchRemoveClassifyTags", param, {
    headers: { "Content-Type": "application/json" },
  })
}

export const inspiration_getUpload = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/uploadIns/collList?${parseParams(param)}`
  );
};

export const inspiration_uploadLook = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/uploadIns/content?${parseParams(param)}`
  );
};

export const inspiration_classifyTree = async function () {
  return await httpRequest.get(`${linggan_host}/classify/tree`);
};

export const inspiration_builderOptions = (classifyList) => {
  return classifyList.map((item) => {
    return {
      value: item.classifyId,
      label: item.name,
      children:
        item.children != null
          ? inspiration_builderOptions(item.children)
          : null,
    };
  });
};

export const inspiration_imgListUpload = async function (param) {
  return await httpRequest.post(linggan_host + "/uploadIns/batchSave", param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const inspiration_getHotWord = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/hotWord/hotword?${parseParams(param)}`
  );
};

// 开放搜索
export const hotWordAutoData = async function (param) {
  return await httpRequest.get(
    `${host}/openSearch/totalCount?${parseParams(param)}`
  );
};

// 灵感搜索热词新增
export const inspiration_hotWordSave = async function (param) {
  return await httpRequest.post(`${linggan_host}/hotWord/save`, param);
};

// 查询图集列表
export const getCollListInAtlas = async function (param) {
  return await httpRequest.get2(
    `${linggan_host}/coll/list`, param
  );
};

// 修改首页图集排序
export const updateHomeOrder = async function (param) {
  return await httpRequest.post(`${linggan_host}/coll/homePage/order`, param);
};

// 修改首页推荐
export const updateHomeRecommend = async function (param) {
  return await httpRequest.post(`${linggan_host}/coll/homePage/recommend`, param);
};
// 修改图集vip状态
export const updateVip = async function (param) {
  return await httpRequest.post(`${linggan_host}/coll/updateVip`, param);
};

// 查看图集详情
export const fetchCollDetail = async function (param) {
  return await httpRequest.get2(
    `${linggan_host}/coll/detail`, param
  );
};

// 设为图集封面
export const setToCover = async function (param) {
  return await httpRequest.post(
    `${linggan_host}/coll/cover`, param
  );
};

// 修改图集标题和描述
export const updateCollNameAndDescription = async function (param) {
  return await httpRequest.post(
    `${linggan_host}/coll/update`, param
  );
};

// 灵感集下面的灵感列表
export const getContentListInAtlas = async function (collId) {
  return await httpRequest.get(
    `${linggan_host}/uploadIns/content?collId=${collId}`
  );
};

// 查询灵感图列表
export const getInsListInAtlas = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/ins/list?page=${param.page}&size=50&insId=${param.insId}&firstClassifyId=${param.firstClassifyId}&secondClassifyId=${param.secondClassifyId}&thirdClassifyId=${param.thirdClassifyId}`
  );
};

// 查询标签列表
export const getTagList = async function (param) {
  let link = `${linggan_host}/tag/list?page=${param.page}&size=50&status=${param.status}`;
  if (param.column) {
    link += `&column=${param.column}&sort=${param.sort}`;
  }
  console.log("link", link);
  return await httpRequest.get(link);
};

// 不同标签的数目
export const getTagCount = async function () {
  return await httpRequest.get(`${linggan_host}/tag/count`);
};

// 根据标签获取内容
export const getTagContent = async function (params) {
  return await httpRequest.get(
    `${linggan_host}/tag/content?tagReviewId=${params.tagReviewId}&page=${params.page}&pageSize=${params.pageSize}`
  );
};

// 删除灵感图
export const getTagDelIns = async function ({ word, insId }) {
  return await httpRequest.post(
    `${linggan_host}/tag/delInsTag?word=${word}&insId=${insId}`
  );
};

// 完成审核标签
export const getTagFinish = async function (tagReviewId) {
  return await httpRequest.get(
    `${linggan_host}/tag/finish?tagReviewId=${tagReviewId}`
  );
};

// 全部下架
export const takeoffAll = async function (tagReviewId) {
  return await httpRequest.get(
    `${linggan_host}/tag/takeoffAll?tagReviewId=${tagReviewId}`
  );
};

// 灵感后台 ksm 知识体系维护 获取 10 个候选词
export const getListRecommendTagWorld = async function (data) {
  return await httpRequest.get(
    `${linggan_host}/knowledge/manger/listRecommendTagWord?input=${data}`
  );
};

// 灵感后台 ksm 知识体系维护 获取父级
export const getListParentFilter = async function (data) {
  return await httpRequest.get(
    `${linggan_host}/knowledge/manger/listParentFilter?tagWord=${data}`
  );
};

// 灵感后台 ksm 知识体系维护 获取知识体系词
export const getListKnowledge = async function (data) {
  return await httpRequest.post(
    `${linggan_host}/knowledge/manger/listKnowledge`,
    data
  );
};

// 灵感后台 检查用户新增的知识体系词
export const checkAddKnowledge = async function (data) {
  return await httpRequest.post(
    `${linggan_host}/knowledge/manger/checkAddKnowledge`,
    data
  );
};

// 灵感后台 添加知识体系词
export const addKnowledge = async function (data) {
  const username = localStorage.getItem("username");
  return await httpRequest.post(
    `${linggan_host}/knowledge/manger/addKnowledge`,
    data,
    { headers: { userInfo: username } }
  );
};

// 灵感后台 添加近义词
export const addKnowledgeSame = async function (data) {
  const username = localStorage.getItem("username");
  return await httpRequest.post(
    `${linggan_host}/knowledge/manger/addKnowledgeSame`,
    data,
    { headers: { userInfo: username } }
  );
};

export const memberEveryCommoditySave = async function (param) {
  const result = await httpRequest.post(
    host + `/api/everyDayCommodity/save`,
    param
  );
  return result;
};

// 爬取词图片
export const crawlRecord = async function (data) {
  return await httpRequest.post(`${linggan_host}/crawlRecord/list`, data);
};

// 爬取词图片统计
export const crawlRecordSum = async function (data) {
  return await httpRequest.post(`${linggan_host}/crawlRecord/sum`, data);
};

// 审核打标列表页
export const getAuditMarkingList = async (data) => {
  return await httpRequest.post(`${linggan_host}/handle/group/list`, data);
};

// 审核打标列表页审核人今日数据
export const auditMarkingTodayPersonnelInformation = async (data) => {
  return await httpRequest.get(`${linggan_host}/handle/personal/data`, {
    headers: { userInfo: data },
  });
};

// 审核打标每组图片列表
export const getAuditMarkingGroupIns = async (id, needsTag, needStar, finishStatus) => {
  return await httpRequest.get(
    `${linggan_host}/handle/ins/list?groupId=${id}&needTags=${needsTag}&needStar=${needStar}&finishStatus=${finishStatus ? finishStatus : 0}`
  );
};

// 审核打标不通过
export const auditMarkingNoPassGroup = async (data, userInfo) => {
  return await httpRequest.post(
    `${linggan_host}/handle/nopass/batch`,
    // {
    // 	groupId,
    // 	idList,
    // },
    data,
    {
      headers: { userInfo: userInfo },
    }
  );
};

// 审核打标，评星级
export const auditMarkingEvaluate = async (data, header) => {
  return await httpRequest.post(`${linggan_host}/handle/star/rate`, data, {
    headers: { userInfo: header },
  });
};

// 审核打标，获取标签页标签list
export const getAuditMarkingTagsList = async () => {
  return httpRequest.get(`${linggan_host}/handle/tag/style`);
};

// 审核打标，打标签接口
export const auditMarkingTagging = async (data, header) => {
  return httpRequest.post(`${linggan_host}/handle/tagging`, data, {
    headers: { userInfo: header },
  });
};

// 审核打标 根据关键词模糊搜索标签
export const auditMarkingGetTagsList = async (keyword) => {
  return await httpRequest.get(
    `${linggan_host}/handle/tags/list?keyword=${keyword}`
  );
};

// 新增临时标签
export const aditMarkingTaggingAdd = async (data) => {
  return httpRequest.post(`${linggan_host}/handle/tempTag/add`, data);
};

// 审核打标 检查临时标签
export const aditMarkingTaggingCheckTag = (data) => {
  return httpRequest.get(`${linggan_host}/handle/tempTag/check?word=${data}`);
};

// 获取推荐标签
export const aditMarkingTaggingRecommendTaggs = async (data) => {
  return httpRequest.get(
    `${linggan_host}/handle/recommendTag/list?parentId=${data.parentId}&type=${data.type}`
  );
};

// 获取新增标签
export const aditMarkingTaggingGetAddedTaggs = () => {
  return httpRequest.get(`${linggan_host}/handle/tempTag/list`);
};

// 灵感审核后台，驳回重申
export const rejectAndReAudit = async (data, header) => {
  return await httpRequest.post(`${linggan_host}/handle/reCheck/batch`, data, {
    headers: { userInfo: header },
  });
};

/** ================= by chenwei ===================== */

// 搜索节点
export const fetchSearchNode = async searchWord => {
  return httpRequest.get(`${linggan_host}/nodeTag/searchNode?searchNodeName=${searchWord}`);
};

// 获取所有节点
export const fetchAllNodes = async (searchWord, nodeTagType) => {
  return httpRequest.get(`${linggan_host}/nodeTag/getAllNodes?searchWord=${searchWord}&nodeTagType=${nodeTagType}`);
};

// 增加节点
export const addNode = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/addNode`, data);
};

// 节点关系列表
export const fetchNodeRelation = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/getNodeRelation`, data);
};

// 新增节点关系
export const addNewNodeRelation = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/addNewNodeRelation`, data);
};

// 删除节点
export const deleteNodeRelation = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/deleteNodeRelation`, data);
};

// 上传节点管理excel文件
export const uploadNodeTagExcel = () => {
  return `${linggan_host}/nodeTag/uploadNodeTagExcel`;
}

// 获取节点实时数据
export const fetchNodeImgCount = async (nodeTagWord, startDate, endDate) => {
  return httpRequest.get(`${linggan_host}/nodeTag/getNodeImgCount?nodeTagWord=${nodeTagWord}&startDate=${startDate}&endDate=${endDate}`);
};

// 获取节点待验证实时数据
export const fetchPendCheckNodeImgCount = async (nodeTagWord, startDate, endDate) => {
  return httpRequest.get(`${linggan_host}/nodeTag/getPendCheckNodeImgCount?nodeTagWord=${nodeTagWord}&startDate=${startDate}&endDate=${endDate}`);
};

// 获取节点更新策略
export const fetchNodeTagCrawlSetting = async nodeTagWord => {
  return httpRequest.get(`${linggan_host}/nodeTag/getNodeTagCrawlSetting?nodeTagWord=${nodeTagWord}`);
};

// 修改节点更新策略
export const modifyNodeTagCrawlSetting = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/modifyNodeTagCrawlSetting`, data);
};

// 获取爬虫配置列表
export const fetchCrawlTools = async data => {
  return httpRequest.post(`${linggan_host}/crawlToolManage/getCrawlTools`, data);
};

// 新增爬虫配置
export const saveCrawlSetting = async data => {
  return httpRequest.post(`${linggan_host}/crawlToolManage/saveCrawlSetting`, data);
};

// 修改爬虫配置
export const modifyCrawlSetting = async data => {
  return httpRequest.post(`${linggan_host}/crawlToolManage/modifyCrawlSetting`, data);
};

// 更新爬虫工具启停状态
export const updateCrawlStatus = async data => {
  return httpRequest.post(`${linggan_host}/crawlToolManage/updateCrawlStatus`, data);
};

// 获取爬虫配置详情
export const fetchCrawlToolDetail = async crawlToolId => {
  return httpRequest.get(`${linggan_host}/crawlToolManage/getCrawlToolDetail?crawlToolId=${crawlToolId}`);
};

// 获取爬取来源列表
export const fetchImgAuditCrawlSourceList = async () => {
  return await httpRequest.get(`${linggan_host}/backstage/source/list`);
};

// 获取审核列表
export const getImgAuditList = async params => {
  return await httpRequest.get2(`${linggan_host}/backstage/group/list`, params);
};

// 获取分类爬取审核列表
export const getClassifyImgAuditList = async params => {
  return await httpRequest.get2(`${linggan_host}/pinterest/backstage/group/list`, params);
};

// 获取审核图组详情
export const fetchImgAuditDetail = async (params, username) => {
  return await httpRequest.get2(`${linggan_host}/backstage/group/detail`, params, {
    headers: { userInfo: username },
  });
}

// 获取分类爬取审核图组详情
export const fetchClassifyImgAuditDetail = async (params, username) => {
  return await httpRequest.get2(`${linggan_host}/pinterest/backstage/group/detail`, params, {
    headers: { userInfo: username },
  });
}

// 审核通过
export const imgAuditWithPass = async (data, username) => {
  return await httpRequest.post(`${linggan_host}/backstage/batchPass`, data, {
    headers: { userInfo: username },
  });
};

// 分类爬取审核批量通过
export const classifyImgAuditWithPass = async (data, username) => {
  return await httpRequest.post(`${linggan_host}/pinterest/backstage/batchPass`, data, {
    headers: { userInfo: username },
  });
};

// 删除不通过图片
export const deleteNoPassImg = async (data, username) => {
  return await httpRequest.post(`${linggan_host}/backstage/batchDelete`, data, {
    headers: { userInfo: username },
  });
};

// 查看审核通过的图片
export const checkAuditPassImg = async params => {
  return await httpRequest.get2(`${linggan_host}/backstage/pass/list`, params);
};

// 获取分类审核列表
export const fetchClassifyAuditList = async params => {
  return await httpRequest.get2(`${linggan_host}/old/backstage/list`, params);
};

// 获取分类审核图组详情
export const fetchClassifyAuditDetail = async (params, username) => {
  return await httpRequest.get2(`${linggan_host}/old/backstage/detail`, params, {
    headers: { userInfo: username },
  });
};

// 获取搜索词对应的分类信息
export const fetchClassifyInfo = async params => {
  return await httpRequest.get2(`${linggan_host}/old/backstage/getClassify`, params);
};

// 查看分类过的图片
export const checkClassifyAuditPassImg = async params => {
  return await httpRequest.get2(`${linggan_host}/old/backstage/pass/list`, params);
};

// 分类审核打标
export const classifyAuditTag = async (data, username) => {
  return await httpRequest.post(`${linggan_host}/old/backstage/tag`, data, {
    headers: { userInfo: username },
  });
};

export const backstageList = async params => {
  return await httpRequest.get2(`${linggan_host}/old/picture/backstage/list`, params)
}

export const backstageInsDeal = async data => {
  return await httpRequest.post(`${linggan_host}/old/picture/backstage/ins/deal`, data)
}

export const backstageSearchWordPass = async data => {
  return await httpRequest.post(`${linggan_host}/old/picture/backstage/searchWord/pass`, data)
}

export const ontologyList = async () => {
  return await httpRequest.get2(`${linggan_host}/ontology/list`)
}

export const ontologyProperties = async () => {
  return await httpRequest.get2(`${linggan_host}/ontology/properties`)
}

export const ontologyListPropertysByEntityId = async (params) => {
  return await httpRequest.get2(`${linggan_host}/ontology/listPropertyOfClassify`, params);
}

export const ontologyClassifyDel = async (data) => {
  return await httpRequest.post(`${linggan_host}/ontology/classify/del`, data)
}

export const ontologyPropertyDel = async (data) => {
  return await httpRequest.post(`${linggan_host}/ontology/property/del`, data)
}

export const ontologyClassifyAdd = async (data) => {
  return await httpRequest.post(`${linggan_host}/ontology/classify/add`, data)
}

export const ontologyPropertyAdd = async (data) => {
  return await httpRequest.post(`${linggan_host}/ontology/property/add`, data)
}

export const ontologyClassifyEdit = async (data) => {
  return await httpRequest.post(`${linggan_host}/ontology/classify/edit`, data)
}

export const ontologyPropertyEdit = async (data) => {
  return await httpRequest.post(`${linggan_host}/ontology/property/edit`, data)
}

export const ontologyBrushData = async (data, username) => {
  return await httpRequest.post(`${linggan_host}/migrate/commitMigrateTask`, data, {
    headers: { userInfo: username },
  })
}

// 搜索补充标签
export const searchOtherWords = async (supplementWord) => {
  return await httpRequest.get(`${linggan_host}/ontology/supplement/search?supplementWord=${supplementWord}`)
}
// 增加补充标签
export const addOtherWords = async (params) => {
  return await httpRequest.get(`${linggan_host}/ontology/supplement/add?supplementWord=${params.supplementWord}&translationWord=${params.translationWord}`)
}
// 删除补充标签
export const delOtherWords = async (supplementWord) => {
  return await httpRequest.get(`${linggan_host}/ontology/supplement/del?supplementWord=${supplementWord}`)
}
// 修改补充标签
export const editOtherWords = async (data) => {
  return await httpRequest.post(`${linggan_host}/ontology/supplement/edit`, data)
}

// 获取图片分类属性和补充标签
export const fetchInsAllTag = async (insId) => {
  return await httpRequest.get(`${linggan_host}/search/getInsImgTag?insId=${insId}`);
};

// 修改图片分类属性和补充标签
export const updateInsImgTag = async (data) => {
  return await httpRequest.post(`${linggan_host}/search/updateInsImgTag`, data);
};

// 搜索图集管理列表
export const searchCollList = async (data) => {
  return await httpRequest.post(`${linggan_host}/coll/searchCollList`, data);
};

// 搜索图集侧边栏
export const tagInfo = async (collId) => {
  return await httpRequest.get(`${linggan_host}/coll/tagInfo?collId=${collId}`);
};

// 搜索图集侧边栏更新
export const updateTagInfo = async (data) => {
  return await httpRequest.post(`${linggan_host}/coll/updateTagInfo`, data);
};

// 悬浮详情
export const popDetail = async (insId) => {
  return await httpRequest.get(`${linggan_host}/search/detail?insId=${insId}`);
};

// 屏蔽搜索词
export const sensitiveWord = async (word) => {
  return await httpRequest.get(`${linggan_host}/search/addSensitiveWord?keyword=${word}`);
};

// 图片id列表
export const listByInsIds = async (data) => {
  return await httpRequest.post(`${linggan_host}/search/listByInsIds`, data);
};

// 搜索词列表
export const listByWord = async (params) => {
  return await httpRequest.get2(`${linggan_host}/search/listByWord`, params);
};

// 批量删除灵感图
export const batchDelIns = async (data) => {
  return await httpRequest.post(`${linggan_host}/es/batchDelIns`, data);
};

// 去除图片Png标识
export const removeImgPng = async (insIdStr, username) => {
  return await httpRequest.get(`${linggan_host}/ins/removeImgPng?insIdStr=${insIdStr}`, {
    headers: { userInfo: username },
  });
};

// 清除灵感用户vip权益
export const removeInsUserVip = async (data, username) => {
  return await httpRequest.post(`${linggan_host}/vip/removeInsUserVip`, data, {
    headers: { userInfo: username },
  });
};

// 搜索图集侧边栏重新打标
export const commitReMarkPictureInCollTask = async (collId, username) => {
  return await httpRequest.get(`${linggan_host}/coll/commitReMarkPictureInCollTask?collId=${collId}`, {
    headers: { userInfo: username },
  });
};

// 黑名单删除p站账号url
export const setBlackUser = async (data, username) => {
  return await httpRequest.post(`${linggan_host}/pinterest/backstage/setBlackUser`, data, {
    headers: { userInfo: username },
  });
};